var map = {
	"./1.png": 390,
	"./10 - Copy.png": 1489,
	"./10.png": 491,
	"./11.png": 492,
	"./12.png": 493,
	"./13.png": 494,
	"./14.png": 495,
	"./15.png": 496,
	"./16.png": 497,
	"./17.png": 498,
	"./18.png": 499,
	"./19.png": 500,
	"./2.png": 391,
	"./20.png": 501,
	"./21.png": 502,
	"./22.png": 503,
	"./24.png": 504,
	"./25.png": 505,
	"./26.png": 284,
	"./27.png": 506,
	"./28.png": 507,
	"./29.png": 508,
	"./31.png": 397,
	"./32.png": 398,
	"./33.png": 218,
	"./34.png": 304,
	"./35.png": 219,
	"./4.png": 392,
	"./5.png": 393,
	"./6.png": 394,
	"./7.png": 395,
	"./8.png": 396,
	"./9.png": 490,
	"./AAVE.png": 1490,
	"./ADA.png": 1491,
	"./ALCRYP.png": 950,
	"./AMZN.png": 1492,
	"./APPL - Copy.png": 1493,
	"./APPL.png": 1494,
	"./AVAX.png": 1495,
	"./BCH.png": 825,
	"./BCM.png": 1496,
	"./BEAM.png": 1497,
	"./BNB.png": 551,
	"./BTC.png": 1498,
	"./BTCB.png": 552,
	"./BTCY.png": 1499,
	"./BUSD.png": 1500,
	"./CAKE.png": 1501,
	"./CHZ.png": 1502,
	"./CRYC10.png": 951,
	"./DAI.png": 826,
	"./DOGE.png": 827,
	"./DOT.png": 828,
	"./DaCrazy.png": 1503,
	"./EPS.png": 1504,
	"./EQSTK.png": 952,
	"./ETH.png": 829,
	"./FTM.png": 1505,
	"./FTT.png": 830,
	"./GOOGL.png": 1506,
	"./IBAT.png": 1507,
	"./IN500.png": 831,
	"./IN500_logo.png": 249,
	"./IN500_old.png": 1508,
	"./INDXXF.png": 953,
	"./INEX-ETH.png": 1509,
	"./INEX-ETHEREUM.png": 1510,
	"./INEX-POLYGON.png": 1511,
	"./INEX.png": 550,
	"./INEX_old.png": 1512,
	"./INJ.png": 1513,
	"./INXC.png": 832,
	"./INXC_logo.png": 250,
	"./INXC_old.png": 1514,
	"./INXP.png": 833,
	"./IUSD+.png": 834,
	"./IUSD+_old.png": 1515,
	"./IUSD.png": 1516,
	"./IUSDP.png": 1517,
	"./IUSDP_logo.png": 203,
	"./LBlock.png": 1518,
	"./LEO.png": 835,
	"./LINK.png": 836,
	"./LTC.png": 837,
	"./MANA.png": 1519,
	"./MATIC.png": 838,
	"./META.png": 1520,
	"./MSFT.png": 1521,
	"./NEAR.png": 1522,
	"./NOT.png": 1523,
	"./NVDA.png": 1524,
	"./PEP.png": 1525,
	"./PYTH.png": 1526,
	"./RUNE.png": 1527,
	"./SHIB.png": 839,
	"./SNP500.png": 1528,
	"./SOL.png": 840,
	"./SPX.png": 1529,
	"./SUI.png": 1530,
	"./THETA.png": 1531,
	"./TLSA.png": 1532,
	"./TOB.png": 954,
	"./TON.png": 841,
	"./TRX.png": 842,
	"./TSLA.png": 1533,
	"./TUSD.png": 553,
	"./USD.png": 201,
	"./USDC.png": 843,
	"./USDT.png": 1534,
	"./VET.png": 1535,
	"./WIBS.png": 844,
	"./WIBS_1.png": 1536,
	"./XLM.png": 1537,
	"./XRP.png": 845,
	"./_IUSD.png": 1538,
	"./eth new PP lpgo 1.png": 1539,
	"./inxf.png": 1540,
	"./old/ALCRYP.png": 1541,
	"./old/AMZN.png": 1542,
	"./old/APPL.png": 1543,
	"./old/BCM.png": 1544,
	"./old/CRYC10.png": 1545,
	"./old/EQSTK.png": 1546,
	"./old/GOOGL.png": 1547,
	"./old/IN500.png": 1548,
	"./old/IN500_logo.png": 1549,
	"./old/INDXXF.png": 1550,
	"./old/INEX.png": 1551,
	"./old/INXC.png": 1552,
	"./old/INXC_logo.png": 1553,
	"./old/IUSD.png": 1554,
	"./old/META.png": 1555,
	"./old/MSFT.png": 1556,
	"./old/NVDA.png": 1557,
	"./old/PEP.png": 1558,
	"./old/SNP500.png": 1559,
	"./old/TLSA.png": 1560,
	"./old/TOB.png": 1561
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55;